import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as RedeemIcon } from '../icons/RedeemIcon.svg';
import {
    DARK_GREY,
    DEEP_PURPLE,
    DEEP_PURPLE_HOVERED,
    DEEP_PURPLE_PRESSED,
    GREEN,
    LIGHTER_GREY,
    WHITE,
  } from '../styles/colors';

const styles = {
    input: {
      display: 'flex',
      '& .MuiFilledInput-root': {
        borderRadius: 0,
        color: DARK_GREY,
        background: WHITE,
        '&:hover': {
          '&::before': {
            border: 'none',
          },
          '&::after': {
            border: 'none',
          },
        },
        '&::before': {
          border: 'none',
        },
        '&::after': {
          border: 'none',
        },
      },
    },
    createAccountBtn: {
      width: '100%',
      maxWidth: '600px',
      padding: '15px 0',
      background: DEEP_PURPLE,
      borderRadius: '50px',
      boxShadow: 'none',
      fontSize: '12px',
      fontFamily: 'GeometriaExtraBold',
      fontWeight: 900,
      '&: hover': {
        background: DEEP_PURPLE_HOVERED,
      },
      '&:active': {
        background: DEEP_PURPLE_PRESSED,
      },
    },
    box1: {
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      minHeight: '300px',
      padding: '120px 20px 15px',
      bgcolor: GREEN,
      color: WHITE,
      textAlign: 'center',
    },
    box2: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '-15px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      minHeight: '450px',
      padding: '30px 20px',
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
      bgcolor: LIGHTER_GREY,
      color: DARK_GREY,
      textAlign: 'center',
    },
  };

export const SubHeader = ({ children, bgcolor }) => {
    return (
        <Box
        sx={{ ...styles.box1, bgcolor }}
        component="section"
      >
        <Box>
          <Typography
            sx={{ fontSize: '30px' }}
            variant="h5"
            component="h1"
            gutterBottom
          >
            {children}
          </Typography>
        </Box>
        <RedeemIcon />
      </Box>
    )
}

SubHeader.propTypes = {
    children: PropTypes.node,
    bgcolor: PropTypes.string,
}